"use strict";
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORIES_TO_DISPLAY = void 0;
exports.isCategoryInDisplayMap = isCategoryInDisplayMap;
exports.CATEGORIES_TO_DISPLAY = {
    livesex: {
        allgirls: "allgirls_label",
        bigtits: "bigtits",
        mature: "milf",
        teen: "teen_label",
        asian: "asian",
        latina: "latina",
        ebony: "ebony",
        bbw: "bbw",
        bondage: "bdsm",
        anal: "anal",
        granny: "granny",
        couples: "couples",
        lesbian: "lesbian",
        feet: "feet",
        hairy: "hairy",
        blonde: "blonde",
        brunette: "brunette",
        redhead: "redhead",
        petite: "petite",
        smalltits: "smalltits",
        pregnant: "pregnant",
        mobile: "mobile",
    },
    guycams: {
        allcams: "allguys_label",
        allguys: "allguys_label",
        couplesguy: "couplesguy",
        blackguy: "blackguy",
        bigcock: "bigcock",
        gay: "gay",
        straight: "straight",
        matureguy: "matureguy",
        daddy: "daddy",
        muscle: "muscule",
        latino: "latino",
        uncut: "uncut",
        alternadudes: "alternadudes",
        analguy: "anal",
        bear: "bear",
        asianguy: "asianguy",
        athleticguy: "athleticguy",
        bdsm: "bdsm",
        guynextdoor: "guynextdoor",
        guyfriends: "guyfriends",
        bi: "bi",
        groupsex: "groupsex",
        mobileguy: "mobile",
    },
    transcams: {
        allcams: "alltrans_label",
        alltrans: "alltrans_label",
        transgirl: "transgirl",
        transguy: "transguy",
        tsbigcock: "tsbigcock",
        tsbigtits: "tsbigtits",
        tslatino: "tslatino",
        tsasian: "tsasian",
        tsblackguy: "tsblackguy",
        tssmalltits: "tssmalltits",
        tsuncut: "tsuncut",
        tsbdsm: "tsbdsm",
        tshugetits: "tshugetits",
        tsmediumtits: "tsmediumtits",
        tsmobile: "mobile",
    },
};
function isCategoryInDisplayMap(category) {
    return Object.values(exports.CATEGORIES_TO_DISPLAY).some(function (section) { return Object.hasOwn(section, category); });
}
//# sourceMappingURL=Categories.js.map